import IconProps from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function CheckmarkIcon({ color }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<g fill={color ?? '#FFFFFF'} fillRule="nonzero" transform="translate(-255 -583)">
					<path d="M271.988 586.537l-10.037 10.307a.557.557 0 01-.772 0l-5.425-5.2c-.213-.207-.213-.617 0-.825l2.015-2.303c.213-.207.753-.207.966 0l2.43 2.303 7.348-7.663a.556.556 0 01.773 0l2.702 2.63a.52.52 0 010 .751z" />
				</g>
			</g>
		</svg>
	);
}

export default CheckmarkIcon;
